import instance from "../Utils/Instance"

export const getSchools = () => {
  return instance({
    method: 'get',
    url: 'schools/all'
  })
}